import React, { useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";
import { red } from "@mui/material/colors";

export default function CheckboxLabels({ labels = [], onChange = () => {} }) {
  const [checkedState, setCheckedState] = useState(
    labels?.map((label) => ({ label, checked: false }))
  );

  const handleCheckChange = (index) => {
    const updatedCheck = checkedState.map((item, i) => {
      if (i === index) {
        return { ...item, checked: !item.checked };
      }
      return item;
    });
    setCheckedState(updatedCheck);
    onChange(updatedCheck);
  };

  return (
    <Grid
      container
      rowSpacing={0.5}
      columnSpacing={{ xs: 1, sm: 4, md: 6, lg: 7 }}
    >
      {checkedState?.map((item, index) => (
        <Grid item xs={12} sm={12} md={12} lg={6} key={index}>
          <FormControlLabel
            control={
              <Checkbox
                style={{
                  transform: "scale(1.5)",
                  color:
                    item?.label === "Police Complaint" ||
                    item.label === "De-Empanel Hospital" ||
                    item.label === "Negative Garage"
                      ? ""
                      : "#ccc",
                }}
                disableRipple
                checked={item.checked}
                onChange={() => handleCheckChange(index)}
                sx={{
                  "&.Mui-checked": {
                    color: red[400],
                    transition: "0.3s ease",
                    "& svg": {
                      transition: "transform 0.15s ease-in-out",
                    },
                  },
                }}
              />
            }
            label={
              <p
                style={{
                  fontSize: "1.4rem",
                  color:
                    item?.label === "Police Complaint" ||
                    item.label === "De-Empanel Hospital" ||
                    item.label === "Negative Garage"
                      ? "#242424"
                      : "#ccc",
                }}
              >
                {item.label}
              </p>
            }
            sx={{
              whiteSpace: "nowrap",
              fontWeight: 400,
              color: "#505050",
              pointerEvents:
                item?.label === "Police Complaint" ||
                item.label === "De-Empanel Hospital" ||
                item.label === "Negative Garage"
                  ? ""
                  : "none",
            }}
          />
        </Grid>
      ))}
    </Grid>
  );
}
